<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        รายงานสรุปรายได้รายวัน
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">RPFI05</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        Carpark Revenue Summary — ยอดเงินตาม type_fee × ประเภทรถ (ช่วงวันที่)
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="rows.length === 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!hasSearched() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'ดูแบบ PDF' }}
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4 no-print">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">receipt_long</span>
          เงื่อนไขรายงาน
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน
      </div>

      <div class="flex flex-col lg:flex-row lg:items-end gap-3 max-w-3xl">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3 flex-1">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">จากวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ startDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #startDatePicker type="date" [(ngModel)]="startDate" (ngModelChange)="onFilterChange()"
                [max]="endDate || undefined" (click)="startDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ถึงวันที่</label>
            <div
              class="relative w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200 overflow-hidden">
              <div class="absolute inset-0 flex items-center justify-between px-3 font-bold text-sm text-slate-600 dark:text-slate-300 pointer-events-none">
                <span>{{ endDate | date:'dd/MM/yyyy' }}</span>
                <span class="material-icons text-slate-400 text-lg">calendar_today</span>
              </div>
              <input #endDatePicker type="date" [(ngModel)]="endDate" (ngModelChange)="onFilterChange()"
                [min]="startDate || undefined" [max]="maxEndDate" (click)="endDatePicker.showPicker()"
                class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0 [color-scheme:light] dark:[color-scheme:dark]">
            </div>
          </div>
        </div>
        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 shrink-0 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">search</span>
          {{ isLoading() ? 'กำลังค้นหา...' : 'ค้นหา' }}
        </button>
      </div>
      <p class="text-[11px] text-slate-400 font-medium">ช่วงวันที่เรียกดูได้สูงสุด 2 เดือน</p>

      <div *ngIf="unmappedAmount > 0"
        class="rounded-xl border border-rose-200 dark:border-rose-900 bg-rose-50/80 dark:bg-rose-950/30 px-4 py-3 text-xs font-semibold text-rose-700 dark:text-rose-300">
        มีรายการที่ยังไม่ map <code class="font-mono">parking_fee.type_fee_id</code>
        รวม {{ unmappedAmount | number:'1.2-2' }} บาท — ไม่ถูกนับในตาราง (กรุณา map fee ให้ครบ)
      </div>
    </div>

    <div class="overflow-x-auto min-h-[280px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse min-w-[1400px] text-xs" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95">
          <tr class="text-[10px] font-bold text-slate-500 uppercase tracking-wider text-center">
            <th class="p-2 border border-slate-200 dark:border-slate-700" rowspan="2">วันที่</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700 bg-violet-50/80 dark:bg-violet-950/30" colspan="1">EV</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700 bg-sky-50/80 dark:bg-sky-950/30" colspan="4">รถยนต์</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700 bg-emerald-50/80 dark:bg-emerald-950/30" colspan="4">รถจักรยานยนต์</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700 bg-amber-50/80 dark:bg-amber-950/30" colspan="7">รวมรายได้</th>
          </tr>
          <tr class="text-[10px] font-bold text-slate-400 text-center whitespace-nowrap">
            <th class="p-2 border border-slate-200 dark:border-slate-700">ค่าชาร์จ</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">จอดรถ</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">สมาชิก</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">บัตรหาย</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">รวม</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">จอดรถ</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">สมาชิก</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">บัตรหาย</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">รวม</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">จอดรถ</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">สมาชิก</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">บัตรหาย</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">ส่วนลด</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">E-stamp</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">คูปอง</th>
            <th class="p-2 border border-slate-200 dark:border-slate-700">รวม</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 tabular-nums">
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-center font-semibold whitespace-nowrap">{{ formatDate(r.paidDate) }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.evCharging | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.carParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.carMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.carLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right font-bold">{{ r.carTotal | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.mcParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.mcMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.mcLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right font-bold">{{ r.mcTotal | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.totalParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.totalMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.totalLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.discountCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.estamp | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right">{{ r.coupon | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-100 dark:border-slate-700 text-right font-black text-amber-700 dark:text-amber-300">{{ r.grandTotal | number:'1.2-2' }}</td>
          </tr>
          <tr *ngIf="!isLoading() && !hasSearched()">
            <td colspan="17" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block opacity-40">search</span>
              <p class="font-bold">เลือกช่วงวันที่ แล้วกดค้นหา</p>
            </td>
          </tr>
          <tr *ngIf="hasSearched() && !isLoading() && rows.length === 0">
            <td colspan="17" class="py-16 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 block opacity-40">search_off</span>
              <p class="font-bold">ไม่พบรายได้ในช่วงวันที่เลือก</p>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="totals && rows.length > 0">
          <tr class="bg-slate-50 dark:bg-slate-900/50 font-bold tabular-nums">
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-center">Total</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.evCharging | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.carParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.carMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.carLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.carTotal | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.mcParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.mcMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.mcLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.mcTotal | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.totalParking | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.totalMember | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.totalLostCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.discountCard | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.estamp | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right">{{ totals.coupon | number:'1.2-2' }}</td>
            <td class="p-2 border border-slate-200 dark:border-slate-700 text-right text-amber-700 dark:text-amber-300">{{ totals.grandTotal | number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'RPFI05 — รายงานสรุปรายได้รายวัน (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isProcessingPdf()" text="กำลังโหลดไฟล์ PDF" detail="โปรดรอสักครู่ . . ."></app-pss-loading>
